import { useCallback, useEffect, useRef, useState } from "react";
import styles from "../../styles/FashionLibrary.module.css";

// A row of cards that scrolls sideways with arrow buttons in its header (no scroll bar), like the
// home page's game rows. title: the heading; extra: anything after it (a note, a "See all" link).
// The arrows turn off at either end; a phone can still swipe the row.
export default function ArrowRow({ title, extra, children, className = "" }) {
  const row = useRef(null);
  const [ends, setEnds] = useState({ start: true, end: false });

  const check = useCallback(() => {
    const el = row.current;
    if (!el) return;
    setEnds({ start: el.scrollLeft <= 2, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 2 });
  }, []);

  useEffect(() => {
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [check, children]);

  const move = (dir) => {
    const el = row.current;
    if (el) el.scrollBy({ left: dir * Math.max(200, el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className={`${styles.arrowRow} ${className}`}>
      <div className={styles.arrowHead}>
        <h2>{title}</h2>
        {extra}
        <span className={styles.arrows}>
          <button type="button" aria-label="Scroll left" disabled={ends.start} onClick={() => move(-1)}>◀</button>
          <button type="button" aria-label="Scroll right" disabled={ends.end} onClick={() => move(1)}>▶</button>
        </span>
      </div>
      <div ref={row} className={styles.arrowCards} onScroll={check}>{children}</div>
    </section>
  );
}
